import logger from 'core/logger/logger';

class QuillSessionStorage {
  private static instance: QuillSessionStorage;

  static getInstance(): QuillSessionStorage {
    if (!QuillSessionStorage.instance) QuillSessionStorage.instance = new QuillSessionStorage();
    return QuillSessionStorage.instance;
  }

  get(key: string, defaultValue?: any): string {
    if (typeof window === 'undefined') return defaultValue || '';

    const localStorageValue = sessionStorage.getItem(key);
    return localStorageValue || defaultValue || '';
  }

  delete(key: string) {
    if (typeof window === 'undefined') return;
    sessionStorage.removeItem(key);
  }

  getStoreDataFromStore() {
    const storeFromSession = {
      smzr: {},
      grmr: {},
    };

    try {
      storeFromSession.smzr = JSON.parse(this.get('smzr', '{}'));
      storeFromSession.grmr = JSON.parse(this.get('grmr', '{}'));
    } catch (error) {
      this.delete('smzr');
      this.delete('grmr');
    }

    return storeFromSession;
  }
}

export default QuillSessionStorage;
